import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import SourceDataFindingsAdd from "@/components/lists/findings/SourceDataFindingsAdd";
import CoordinatingGroupContext from "@/contexts/data/CoordinatingGroupContext";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import MasterGroupContext from "@/contexts/data/MasterGroupContext";
import ParticipantContext from "@/contexts/data/ParticipantContext";
import TrialContext from "@/contexts/data/TrialContext";
import { SourceDataFindingsInstitutionCreateLink, SourceDataFindingsParticipantCreateLink, SourceDataFindingsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const ParticipantSourceDataFindingsAdd: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: masterGroup } = useContext(MasterGroupContext);
    const { data: coordinatingGroup } = useContext(CoordinatingGroupContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: participant } = useContext(ParticipantContext);

    return (
        <>
            <SetLinks 
                createTrialLink={SourceDataFindingsTrialCreateLink} 
                createInstitutionLink={SourceDataFindingsInstitutionCreateLink} 
                createParticipantLink={SourceDataFindingsParticipantCreateLink}  
            />
            <Show show={true}>
                <Typography variant="h1" gutterBottom>
                Findings
                </Typography>
                <SourceDataFindingsAdd 
                    trialId={trial?.id} 
                    masterGroupId={masterGroup?.id}
                    coordinatingGroupId={coordinatingGroup?.id}
                    institutionId={institution?.id}
                    participantId={participant?.id}
                />
            </Show>
        </>
    )
};

export default ParticipantSourceDataFindingsAdd;